import {InjectionToken} from '@angular/core';
import {IziviaTheme} from '../domain/theme/iziviaTheme';

export const THEME = new InjectionToken<IziviaTheme>('Current theme');
